import { layout } from 'src/styles/layout';
import styled from 'styled-components';
import { palette } from 'styles/colors';

export const StyledQuestionAnswerContainer = styled.div`
  background-color: ${palette.white};
  margin: 24px 16px;
  
  @media all and (max-width: 550px) {
    margin: 24px 6px;
  }
`

export const StyledQuestionToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  text-align: left;
  padding: 16px;

  svg {
    min-width: 16px;
    margin-left: 10px;
  }
`

export const StyledQuestionLabel = styled.span`
  font-size: 22px;
  font-weight: 400;
  max-width: 787px;
  
  @media all and (max-width: ${layout.sm}) {
    font-size: 1.1rem;

  }
`

export const StyledAnswer = styled.div`
  padding: 8px 24px 16px 16px;
  font-size: 15px;
  text-align: initial;
  p {
    font-weight: 300;
    line-height: 1.4;
  }

  a {
    color: ${palette.snowFlower};
    text-decoration: none;
  }
`
